import { type App, defineAsyncComponent } from 'vue'

const components = {
  CampaignBriefCard: defineAsyncComponent(() => import('./CampaignBriefCard.vue')),
  CampaignBriefSchedule: defineAsyncComponent(() => import('./CampaignBriefSchedule.vue')),
  CampaignCardGrid: defineAsyncComponent(() => import('./CampaignCardGrid.vue')),
  CampaignDeleteDialog: defineAsyncComponent(() => import('./CampaignDeleteDialog.vue')),
  CampaignEarlierRow: defineAsyncComponent(() => import('./CampaignEarlierRow.vue')),
  CampaignPostGrid: defineAsyncComponent(() => import('./CampaignPostGrid.vue')),
  CampaignBriefBlock: defineAsyncComponent(() => import('./CampaignBriefBlock.vue')),
  CampaignFirstPost: defineAsyncComponent(() => import('./CampaignFirstPost.vue')),
  CampaignPictureCard: defineAsyncComponent(() => import('./CampaignPictureCard.vue')),
  CampaignPostCard: defineAsyncComponent(() => import('./CampaignPostCard.vue')),
  CampaignPostContinueCard: defineAsyncComponent(() => import('./CampaignPostContinueCard.vue')),
  CampaignPostDrawer: defineAsyncComponent(() => import('./CampaignPostDrawer.vue')),
  CampaignPostPill: defineAsyncComponent(() => import('./CampaignPostPill.vue')),
  CampaignPostPicture: defineAsyncComponent(() => import('./CampaignPostPicture.vue')),
  CampaignSubpageTitle: defineAsyncComponent(() => import('./CampaignSubpageTitle.vue')),
  CampaignStartDialog: defineAsyncComponent(() => import('./CampaignStartDialog.vue')),
  CampaignSlimBar: defineAsyncComponent(() => import('./CampaignSlimBar.vue')),
  CampaignArtDirectionCard: defineAsyncComponent(() => import('./CampaignArtDirectionCard.vue')),
  CampaignArtDirectionPanel: defineAsyncComponent(() => import('./CampaignArtDirectionPanel.vue')),
  CampaignBuildPlanCard: defineAsyncComponent(() => import('./CampaignBuildPlanCard.vue')),
  CampaignBuildPlanPanel: defineAsyncComponent(() => import('./CampaignBuildPlanPanel.vue')),
  CampaignBackLink: defineAsyncComponent(() => import('./CampaignBackLink.vue')),
  CampaignBriefDocument: defineAsyncComponent(() => import('./CampaignBriefDocument.vue')),
  CampaignBriefSection: defineAsyncComponent(() => import('./CampaignBriefSection.vue')),
  CampaignConceptTile: defineAsyncComponent(() => import('./CampaignConceptTile.vue')),
  CampaignConceptsPanel: defineAsyncComponent(() => import('./CampaignConceptsPanel.vue')),
  CampaignContinueCard: defineAsyncComponent(() => import('./CampaignContinueCard.vue')),
  CampaignChatHeading: defineAsyncComponent(() => import('./CampaignChatHeading.vue')),
  CampaignDesignerLook: defineAsyncComponent(() => import('./CampaignDesignerLook.vue')),
  CampaignDesignerPanel: defineAsyncComponent(() => import('./CampaignDesignerPanel.vue')),
  CampaignDesignerCopy: defineAsyncComponent(() => import('./CampaignDesignerCopy.vue')),
  CampaignListCard: defineAsyncComponent(() => import('./CampaignListCard.vue')),
  CampaignQuestionsCard: defineAsyncComponent(() => import('./CampaignQuestionsCard.vue')),
  CampaignResultCard: defineAsyncComponent(() => import('./CampaignResultCard.vue')),
  CampaignResultPanel: defineAsyncComponent(() => import('./CampaignResultPanel.vue')),
  CampaignScheduleGroup: defineAsyncComponent(() => import('./CampaignScheduleGroup.vue')),
  CampaignSidePanel: defineAsyncComponent(() => import('./CampaignSidePanel.vue')),
  CampaignStepper: defineAsyncComponent(() => import('./CampaignStepper.vue')),
  CampaignWroteRow: defineAsyncComponent(() => import('./CampaignWroteRow.vue')),
  CampaignsEmptyState: defineAsyncComponent(() => import('./CampaignsEmptyState.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
